// import apiClient from "../config/apiClient";


// export const QueryLabRequest = async (data, prof) => {
//     const user = window.localStorage.getItem("token");
//     const token = user;
//     return await apiClient.get(`/public/portal?url=services/labs?q=${data}&hmo_id=${prof}`, {
//       headers: {
//         Authorization: "Bearer " + token,
//       },
//     });
//   };
  
import apiClient from "../config/apiClient";


export const queryDrugs = async (data, prof) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.get(`/public/portal?url=inventory/drugs?overTheCounter=true%26page=1%26q=${data}%26plusGens=`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  
//24550